export const getConfigInfo = (name, collection) => {
    return collection.find(c => c.name === name) || null
}
